import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';
import {alto, mineShaft} from '/theme/color/secondary.color';
import {createWebEnhancedStyles} from '/util/webStyles.util';

export const styles = createWebEnhancedStyles({
  buttonWrapper: {
    width: '100%',
    paddingHorizontal: indent,
  },
  buttonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: alto,
    backgroundColor: white,
    width: '100%',
    borderRadius: indent * 0.5,
    paddingHorizontal: indent * 0.8,
  },
  buttonTextContainer: {
    flex: 1,
    minWidth: 0,
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: indent * 0.8,
  },
  button: {
    flexShrink: 1,
    marginVertical: indent * 0.5,
    paddingVertical: indent * 0.2,
    width: '100%',
    textAlign: 'center',
  },
  icon: {
    fontSize: 22,
    color: mineShaft,
    marginLeft: indent * 0.5,
  },
});
